module.exports = __webpack_public_path__ + "img/tmcIcon.6a11fc0c.png";